import { MANAGED_USER_ROLES, ManagedUserRole } from "@/services/users";

/** The org manager's page for each user type. */
export const USER_PAGES: Record<
  ManagedUserRole,
  { path: string; title: string; inviteTitle: string }
> = {
  broker: { path: "/brokers", title: "Brokers", inviteTitle: "Invite broker" },
  underwriter: { path: "/underwriters", title: "Underwriters", inviteTitle: "Invite underwriter" },
  admin_support: {
    path: "/admin-support",
    title: "Admin Support",
    inviteTitle: "Invite admin support",
  },
};

/** `value` when it names a user type, else null. */
export const asUserRole = (value: string | null): ManagedUserRole | null =>
  MANAGED_USER_ROLES.find((role) => role === value) ?? null;
